import client from "../config/api.config";
import { AppNotification } from "../types/notification.definition";

const getWebClient = () => client.apiClient;

export function getNotifications() {
  return getWebClient().request<AppNotification[]>({
    method: "get",
    url: "/notifications",
  });
}

export function markNotificationAsRead(id: number) {
  return getWebClient().request<AppNotification>({
    method: "put",
    url: `/notifications/${id}/read`,
  });
}

export function markAllNotificationsAsRead() {
  return getWebClient().request<void>({
    method: "put",
    url: "/notifications/read-all",
  });
}

export function deleteNotification(id: number) {
  return getWebClient().request<void>({
    method: "delete",
    url: `/notifications/${id}`,
  });
}
